import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Context and Components
import { NotificationProvider, useNotifications } from "./Components/Context/NotificationContext";
import NotificationPopup from "./Components/Common/NotificationPopup";
import GlobalPopup from "./Components/Common/GlobalPopup";
import GlobalNotificationWatcher from "./Components/Common/GlobalNotificationWatcher";
import "./assets/scss/themes.scss";
import Route from "./Routes";

// ✅ Wrapper for accessing context inside NotificationProvider
const GlobalPopupWrapper = () => {
  const { globalPopup, closeGlobalPopup } = useNotifications();
  return (
    <GlobalPopup
      show={globalPopup.show}
      message={globalPopup.message}
      onClose={closeGlobalPopup}
    />
  );
};

function App() {
  const userId = localStorage.getItem("userId");

  return (
    <React.Fragment>
      {/* ✅ Wrap entire app in notification provider */}
      <NotificationProvider userId={userId}>
        {/* ✅ Optional watcher for global booking polling */}
        <GlobalNotificationWatcher />

        {/* ✅ All your routes */}
        <Route />

        {/* ✅ Bottom-right small toast popups */}
        <NotificationPopup />

        {/* ✅ Center-screen modal popup */}
        <GlobalPopupWrapper />
      </NotificationProvider>

      {/* ✅ Toastify for system toasts */}
      <ToastContainer />
    </React.Fragment>
  );
}

export default App;
